import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";

export const CUSTOMER_SERVICE_ORDER_FIELDS = `
    id
    trackingNumber
    overallStatus
    orderTime
    sortingCode
    receivedAtHub
    destHubArrivedAt
    destWarehouseArrivedAt
    deliverAt
    lastDeliveryScanTime
    deliveredAt
    isHasBeenSetException
    isAbnormal
    exceptionStatus
    exceptionReasonCode
    markExceptionAt
    nextAction
    prePickupHubName
    pickupHubName
    dsp {
        id
        name
    }
`;

export const GET_CUSTOMER_SERVICE_PARCELS_LITE = gql`
    query CustomerServiceParcelsLite($filters: OrderFiltersTypeInput,
                                     $pageRequest: PageRequestTypeInput) {
        getOrderListingForCentral: getOrderListingForCustomerServiceParcelsLite(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${CUSTOMER_SERVICE_ORDER_FIELDS}
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export interface CustomerServiceOrderListResponse {
    getOrderListingForCentral: CustomerServiceOrderListingResponseType;
}

export interface CustomerServiceOrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    accessiblePages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

